import { options_theme_darkmode_toggle } from './DarkModeOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let DarkModeOption: LazyOption = createLazyOption(
    {
        key: 'darkMode',
        titleStringKey: options_theme_darkmode_toggle,
        searchTermsStringKey: options_theme_darkmode_toggle,
        allowedOptionKeys: ['Theme'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default DarkModeOption;
